import { useCallback, useState } from "react";

import setupLocalStorageAPI from "utils/setupLocalStorageAPI";

const micSetupStorage = setupLocalStorageAPI("medicalScribeMicSetup");
const micSetupCompletedAtStorage = setupLocalStorageAPI(
  "medicalScribeMicSetupCompletedAt"
);

export function useMicrophoneSetup() {
  const [isSetupComplete, setIsSetupComplete] = useState<boolean>(
    () => micSetupStorage.getData(false)
  );

  const [micSetupCompletedAt, setMicSetupCompletedAt] = useState<
    string | null
  >(() => micSetupCompletedAtStorage.getData(null));

  const markSetupComplete = useCallback(() => {
    const now = new Date().toISOString();
    micSetupStorage.updateData(true);
    micSetupCompletedAtStorage.updateData(now);
    setIsSetupComplete(true);
    setMicSetupCompletedAt(now);
  }, []);

  // Called when a recording session ends so a stale micSetupCompletedAt from a
  // previous session cannot suppress the prompt after a subsequent failure.
  const clearMicSetupCompletedAt = useCallback(() => {
    micSetupCompletedAtStorage.updateData(null);
    setMicSetupCompletedAt(null);
  }, []);

  // Reads directly from localStorage so callers always get the freshest value
  // even when another hook instance (e.g. DeviceSettingsModal) wrote it.
  const getMicSetupCompletedAt = useCallback(
    () => micSetupCompletedAtStorage.getData(null) as string | null,
    []
  );

  return {
    isSetupComplete,
    micSetupCompletedAt,
    getMicSetupCompletedAt,
    markSetupComplete,
    clearMicSetupCompletedAt
  };
}
